export enum SettingsNotificationType {
  ENERGY_REFILLED = 'energyRefilled',
  POKE = 'poke',
  OFFLINE_PROFIT = 'offlineProfit',
  REFERRAL = 'referral'
}